//import React, { useContext } from 'react';
import { PageHeader, Page, PageContent, Box, Text } from 'grommet';
import { DashboardGrid } from '../../components/DashboardGrid'; 
import ProductLedHomeTilesCSV from '../../data/productled/ProductLedHomeTiles.csv';

export const ProductLedHome = () => {
  //const [user, setUser] = useState(defaultUser);
  //const size = useContext(ResponsiveContext);

  return (
    <Page flex="grow" background="background-back">

      <Box background="url('/images/home-banner.png')" height="200px" margin={{ top: 'none'}}>
        <Box margin={{ top: 'none', left: 'large' }}>
                        <PageHeader pad={{ top: '15px', bottom: '15px' }} 
                          title={<Text color="black" size="xxlarge" weight="bolder" style={{fontWeight: 'bold'}}>Product Led IT @ HPE</Text>} 
                          subtitle={'Driving modern E2E outcome and experience focus.'}
                          style={{ color: 'black' }}
                          size='medium'/>
        </Box>                  
      </Box> 

      <PageContent flex="grow">
          <Text weight="bold">Under construction- content upcoming and temp placeholders below.</Text>
          <DashboardGrid filePath={ProductLedHomeTilesCSV} />
      </PageContent>  

    </Page>
  );
};